import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

/**
 * Safely clears the search query, letting the caller reset its own state before doing so.
 *
  @param {AppRouterInstance} router - NextJS app router instance, url without search query is pushed to this.
  @param {() => void} beforeClear - Optional paramless function called before search query is cleared.
**/
export function clearSearchQuery(router: AppRouterInstance, beforeClear?: () => void) {
  if (typeof window === 'undefined') {
    return;
  }

  beforeClear?.();

  // Remove search query and reload page, preserving testTheme
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.delete('query');

  const targetUrl = currentUrl.pathname + (currentUrl.search ? currentUrl.search : '');

  if (currentUrl.pathname.includes('/entry/')) {
    // can't use router here because it causes page navigation and is intercepted by @modal route.
    // a null state makes next sync its router to the new url without a fetch; with its own state kept
    // it would not, and its next update would put the query back
    window.history.replaceState(null, '', targetUrl);
  } else {
    router.push(targetUrl);
  }
}
